// extracted by mini-css-extract-plugin
module.exports = {"recircWrapper":"Recirc-module--recircWrapper--1T1Cc"};